import * as React from 'react'

import { usePartnerEditProfile } from './hooks'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CMultiSelect,
  CRow,
} from '@coreui/react-pro'
import { submitEditPartner, setPartnerEditProfile } from './model'
import { cilFullscreen } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { partnerStatus, partnerStatusHumanToNumber } from '../const'

type Props = {
  className?: string
}

export const PartnerEditProfile = ({ className }: Props) => {
  let { partnerEditProfile, loading } = usePartnerEditProfile()

  const { id, status } = partnerEditProfile

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    setPartnerEditProfile({
      ...partnerEditProfile,
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  const handlePartnerStatusChange = (objectKey: string, value: any) => {
    setPartnerEditProfile({
      ...partnerEditProfile,
      [objectKey]: value,
    })
  }

  return (
    <>
      <CCol xs={12} className={className}>
        <CCard className="mb-4">
          <CCardHeader className="d-sm-flex justify-content-between align-items-center">
            <strong>Edit partner {id}</strong>
            <CButton
              color="secondary"
              className="me-2"
              title={'<- Back'}
              href={'/partner/' + id}
            >
              <CIcon icon={cilFullscreen} />
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CRow>
                <CCol xs={4}>
                  <div className="mb-3">
                    <CMultiSelect
                      id="status"
                      label="status"
                      multiple={false}
                      options={partnerStatus.map((item) => {
                        if (
                          partnerStatusHumanToNumber(status) == item.value ||
                          status == item.value
                        ) {
                          return { ...item, selected: true }
                        } else {
                          return { ...item, selected: false }
                        }
                      })}
                      onChange={(event) => {
                        let partnerStatus: (string | number)[] = []
                        event.forEach((item) => partnerStatus.push(item.value))
                        handlePartnerStatusChange('status', partnerStatus.pop())
                      }}
                    ></CMultiSelect>
                  </div>
                </CCol>
              </CRow>
              <CButton
                className="mb-3"
                disabled={loading}
                onClick={() => submitEditPartner(partnerEditProfile)}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                Save
              </CButton>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </>
  )
}

export const PartnerEditDetail = () => {
  return (
    <div>
      <CRow>
        <PartnerEditProfile></PartnerEditProfile>
      </CRow>
    </div>
  )
}
